import ArticleLayout from '@/components/ArticleLayout';

export default function PrivacyPage() {
  return (
    <ArticleLayout
      title="Privacy Policy"
      description="Privacy policy for the CSSBuy Spreadsheet independent resource website."
      breadcrumbs={[
        { label: 'Home', to: '/' },
        { label: 'Privacy Policy', to: '/privacy-policy' },
      ]}
      lastUpdated="2026-08-30"
    >
      <h2>Introduction</h2>
      <p>
        This Privacy Policy explains how CSSBuy Spreadsheet collects, uses, and protects your information when you visit our website. We are committed to protecting your privacy and handling your data responsibly.
      </p>

      <h2>Information We Collect</h2>
      <p>We may collect the following types of information:</p>
      <ul>
        <li><strong>Usage Data:</strong> Information about how you interact with our website, including pages visited, time spent, and browser type.</li>
        <li><strong>Contact Information:</strong> If you choose to contact us, we may collect your name, email address, and message content.</li>
        <li><strong>Technical Data:</strong> IP address, browser type, operating system, and device information.</li>
      </ul>

      <h2>How We Use Your Information</h2>
      <p>We use collected information for:</p>
      <ul>
        <li>Improving website functionality and user experience</li>
        <li>Responding to inquiries and providing support</li>
        <li>Analyzing website traffic and usage patterns</li>
        <li>Preventing fraud and abuse</li>
      </ul>

      <h2>Data Protection</h2>
      <p>
        We implement reasonable security measures to protect your information. However, no method of transmission over the internet is 100% secure. We cannot guarantee absolute security of your data.
      </p>

      <h2>Third-Party Links</h2>
      <p>
        Our website contains links to external websites, including CSSBuy. We are not responsible for the privacy practices or content of these external sites. We encourage you to review their privacy policies.
      </p>

      <h2>Cookies</h2>
      <p>
        We may use cookies to enhance your browsing experience. You can choose to disable cookies through your browser settings, though this may affect some website functionality.
      </p>

      <h2>Your Rights</h2>
      <p>
        You have the right to access, correct, or delete your personal information. To exercise these rights, please contact us through our contact page.
      </p>

      <h2>Changes to This Policy</h2>
      <p>
        We may update this Privacy Policy from time to time. Any changes will be posted on this page with an updated revision date.
      </p>
    </ArticleLayout>
  );
}